<template>
  <div id="SectionHeader">
    <UIContainer class="SectionHeader__container">
      <template #left>
        <div class="SectionHeader__content">
          <div class="SectionHeader__left">
            <SectionTitle titleTag="h1">
              <template #title>
                Measure an

                <span class="SectionHeader__description"> accurate </span> full
                scope carbon footprint with ease
              </template>
            </SectionTitle>

            <p class="SectionHeader__description-text">
              Cut reporting time by 80%, leverage industry-leading data, and
              gain continuous guidance from our dedicated Climate Expert team.
            </p>

            <!-- Social Proof -->
            <SectionSocialProof class="SectionHeader__social-proof" />

            <!-- CTA Button -->
            <div class="SectionHeader__cta">
              <UIButton size="xl" theme="primary" :to="{ name: 'Contact' }">
                Book a demo
              </UIButton>
            </div>
          </div>
        </div>
      </template>

      <template #right>
        <div class="SectionHeader__image-container">
          <img
            class="SectionHeader__image"
            src="../assets/header/hero.avif"
            alt="Carbon accounting software displaying Scope 1, 2, and 3 emissions breakdown with reduction targets"
            width="800"
            height="600"
            fetchpriority="high"
            loading="eager"
            decoding="async"
            style="width: 100%; height: auto"
          />
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import SectionSocialProof from '@/views/components/sections/SectionSocialProof.vue'
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
</script>

<style lang="scss" scoped>
#SectionHeader {
  .SectionHeader__container {
    padding-top: 2rem;

    @include md {
      padding-top: 4rem;
    }
  }

  .SectionHeader__left {
    max-width: 42rem;
    width: 100%;
  }

  .SectionHeader__content {
    display: flex;
    gap: 2rem;
    flex-direction: column;

    @include md {
      gap: 4rem;
      flex-direction: row;
    }
  }

  .SectionHeader__description {
    font-weight: 600;
    background: linear-gradient(45deg, #023025 0%, #04785e 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }

  .SectionHeader__description-text {
    @include font-size-16px();
    color: $color-ui-gray-cool-600;
    margin-top: 1.5rem;
    max-width: 30rem;

    @include md {
      @include font-size-20px();
    }
  }

  .SectionHeader__social-proof {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .SectionHeader__cta {
    display: flex;
    align-items: center;
    justify-content: center;

    @include md {
      justify-content: flex-start;
    }
  }

  .SectionHeader__image-container {
    margin-top: 1.5rem;

    @include md {
      margin-top: 0;
      margin-left: 2rem;
    }
  }

  .SectionHeader__image {
    width: 100%;
    height: auto;
  }
}
</style>
